import React, { useState } from 'react';
import { interestRates } from '../data/mockData';

function InterestRates() {
  const [activeTab, setActiveTab] = useState('deposit');

  return (
    <div className="bg-white rounded-lg shadow p-4">
      <h2 className="text-xl font-semibold text-green-800 mb-4">อัตราดอกเบี้ย</h2>
      <div className="flex space-x-2 mb-4">
        <button
          className={`px-4 py-2 rounded-md ${
            activeTab === 'deposit'
              ? 'bg-green-800 text-white'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
          onClick={() => setActiveTab('deposit')}
        >
          อัตราดอกเบี้ยเงินฝาก
        </button>
        <button
          className={`px-4 py-2 rounded-md ${
            activeTab === 'loan'
              ? 'bg-green-800 text-white'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
          onClick={() => setActiveTab('loan')}
        >
          อัตราดอกเบี้ยเงินกู้
        </button>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-gray-50">
              <th className="px-4 py-2 text-left text-gray-600">ประเภท</th>
              <th className="px-4 py-2 text-right text-gray-600">อัตรา (%)</th>
            </tr>
          </thead>
          <tbody>
            {(activeTab === 'deposit' ? interestRates.depositRates : interestRates.loanRates).map(
              (rate, index) => (
                <tr key={index} className="border-b">
                  <td className="px-4 py-2 text-gray-800">{rate.type}</td>
                  <td className="px-4 py-2 text-right text-gray-800">{rate.rate.toFixed(2)}</td>
                </tr>
              )
            )}
          </tbody>
        </table>
      </div>
      <div className="text-sm text-gray-500 mt-4">
        เริ่ม ต.ค. 2565
      </div>
    </div>
  );
}

export default InterestRates; 